import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { Alert } from '@mantine/core';
import type { ReactNode } from 'react';
import { Icon } from '../Spinner/Icon';
import type { AlertProps } from './AlertProps';

const AlertIcon = <Icon icon={faTriangleExclamation} />;

export function ErrorAlert(props: AlertProps): ReactNode {
	const icon = props.icon ?? AlertIcon;

	return (
		<Alert c={'red.9'} bg={'red.1'} variant="light" title={props.title} icon={icon}>
			{props.children}
		</Alert>
	);
}
